import { withInstall } from '@element-plus/utils'
import Trend from './src/trend.vue'

export const ElTrend = withInstall(Trend)
export default ElTrend

export * from './src/trend'
